import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["closedText"];

  connect() {
    const allRadios = this.element.querySelectorAll('input[type="radio"]');
    // console.log("All radio buttons:", Array.from(allRadios).map(r => ({ value: r.value, checked: r.checked })))

    allRadios.forEach(radio => {
      radio.addEventListener('change', () => this.toggleTemperature());
    });

    this.toggleTemperature();
  }

    toggleTemperature() {
    const selectedRadio = this.element.querySelector('input[type="radio"]:checked');
    const selectedValue = selectedRadio?.value;

    this.toggleClosedText(selectedValue);

    const event = new CustomEvent("bathing-status-changed", {
      bubbles: true,
      detail: {
        status: selectedValue,
        showTemperature: selectedValue === "open" || selectedValue === "risky"
      }
    });

    this.element.dispatchEvent(event);
  }

  toggleClosedText(selectedValue) {
    if (this.hasClosedTextTarget) {
      if (selectedValue === "closed") {
        this.closedTextTarget.classList.remove("d-none");
      } else {
        this.closedTextTarget.classList.add("d-none");
      }
    }
  }

  handleStatusChange(_event) {
    this.toggleTemperature();
  }
}